export default {
    props: {
        mediaSource: {
            type: String,
            default: undefined,
            kComposite: 'media.source'
        }, 
        mediaTitle: {
            type: String,
            default: undefined,
            kComposite: 'media.title'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-mediaplayer-vue-wrapper/src/KendoMediaPlayer/Media.js